































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { ETableColumnType, ISelectItem, ITableConfig } from '@/interfaces'
import {
  DateRange,
  Dictionary,
  EFacilityMonthlyBillingBatchStatus,
  EZuntaInvoiceType,
  IFacilityMonthlyBillingBatch,
  IUserFacilityMonthlyBillingBatch
} from '@zunta/configurations'
import Table from '@/components/tables/Table.vue'
import Card from '@/components/Card.vue'
import DropdownNav from '@/components/DropdownNav.vue'
import Icon from '@/components/Icon.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import BillingBatchHistoryModal from '@/views/app/admin/pages/billing/components/BillingBatchHistoryModal.vue'
import CreateBatchModal from '@/views/app/admin/pages/billing/pages/components/CreateBatchModal.vue'
import Confirm from '@/components/Confirm.vue'
import Api from '@/api'
import { ChainModule } from '@/store/modules/chain.module'
import { getModule } from 'vuex-module-decorators'
import Status from '@/components/statuses/Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
// @ts-ignore
import Teleport from 'vue2-teleport'

@Component({
  components: {
    ButtonDownloadReport,
    Status,
    Confirm,
    CreateBatchModal,
    BillingBatchHistoryModal,
    DateTimeLabel,
    Icon,
    DropdownNav,
    Card,
    Table,
    Teleport
  }
})
export default class BillingPageTab extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)

  isCreatingBilling: boolean = false
  shouldConfirmCreateBatch: boolean = false
  shouldConfirmDeleteBatch: boolean = false
  shouldConfirmUpdateBatch: boolean = false
  batchIdToDelete: number | null = null
  batchIdToUpdate: number | null = null
  isDeletingBatch: boolean = false

  shouldShowBillingBatchHistory: boolean = false
  historyBatchId: number | null = null

  prevFilters: any = {
    limit: 20,
    skip: 0
  }

  timeout: number = -1

  config: ITableConfig = {
    useQuery: true,
    usePagination: true,
    rowClick: this.goToDetailsPage,
    fetchFunction: this.fetchBillingItems,
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1.5rem - 1px); right: -1.5rem;',
      class: 'rounded-top-bottom'
    },
    columns: [
      {
        minWidth: '90px',
        width: 9,
        key: 'date',
        searchKey: 'date',
        hasSort: true,
        hasSearch: true,
        label: 'Date',
        type: ETableColumnType.date
      },
      {
        class: 'text-right',
        minWidth: '60px',
        width: 6,
        key: 'totalChains',
        searchKey: 'totalChains',
        hasSort: true,
        hasSearch: true,
        label: 'Chains',
        type: ETableColumnType.default
      },
      {
        class: 'text-right',
        minWidth: '60px',
        width: 6,
        key: 'totalFacilities',
        searchKey: 'totalFacilities',
        hasSort: true,
        hasSearch: true,
        label: 'Facilities',
        type: ETableColumnType.default
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '90px',
        width: 9,
        key: 'monthlyFee',
        searchKey: 'monthlyFee',
        hasSort: true,
        hasSearch: true,
        label: 'Net Monthly',
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '90px',
        width: 9,
        key: 'netTotalMailing',
        searchKey: 'netTotalMailing',
        hasSort: true,
        hasSearch: true,
        label: 'Net Mailing',
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '90px',
        width: 9,
        key: 'netCC',
        searchKey: 'netCC',
        hasSort: true,
        hasSearch: true,
        label: 'Net CC',
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '90px',
        width: 9,
        key: 'netECheckTotal',
        searchKey: 'netECheckTotal',
        hasSort: true,
        hasSearch: true,
        label: 'Net eCheck',
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '100px',
        width: 10,
        key: 'totalRevenue',
        searchKey: 'totalRevenue',
        hasSort: true,
        hasSearch: true,
        label: 'Total Revenue',
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '100px',
        width: 10,
        key: 'totalOutStanding',
        searchKey: 'totalOutStanding',
        hasSort: true,
        hasSearch: true,
        label: 'Total OutStanding',
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '80px',
        width: 8,
        key: 'commissionsPaid',
        searchKey: 'commissionsPaid',
        hasSort: true,
        hasSearch: true,
        label: 'Commissions Paid',
        type: ETableColumnType.numberRange
      },
      {
        class: '',
        minWidth: '80px',
        width: 8,
        key: 'status',
        searchKey: 'status',
        hasSort: true,
        hasSearch: true,
        label: 'Status',
        type: ETableColumnType.select,
        options: [
          {
            key: 'paid',
            content: 'Complete',
            value: EFacilityMonthlyBillingBatchStatus.PAID
          },
          {
            key: 'not-paid',
            content: 'Incomplete',
            value: EFacilityMonthlyBillingBatchStatus.NOT_PAID
          }
        ]
      },
      {
        class: 'text-right',
        minWidth: '80px',
        width: 8,
        key: 'actions',
        type: ETableColumnType.actions
      }
    ]
  }

  get batches () {
    return this.$store.state.chain.billingBatches
  }

  get totalBatches () {
    return this.$store.state.chain.totalBatches
  }

  get userId () {
    return this.$route.params.user
  }

  getDotsActions (batch: IFacilityMonthlyBillingBatch): ISelectItem[] {
    const actions = [{
      icon: 'update',
      key: 'update',
      value: 'update',
      content: 'Update'
    }]
    if (batch.status !== EFacilityMonthlyBillingBatchStatus.PAID) {
      actions.push({
        icon: 'trash',
        key: 'remove',
        value: 'remove',
        content: 'Remove'
      })
    }
    return actions
  }

  getBatchStatusHoverLabel (batch: IFacilityMonthlyBillingBatch) {
    if (batch.status === EFacilityMonthlyBillingBatchStatus.PAID) {
      return null
    }
    if (!batch.eCheckCostPerTransaction) {
      return 'Discrepancy'
    }
    return 'Unpaid Items'
  }

  getBillingBatchStatusLabel (status: EFacilityMonthlyBillingBatchStatus) {
    switch (status) {
      case EFacilityMonthlyBillingBatchStatus.PAID:
        return 'Complete'
      case EFacilityMonthlyBillingBatchStatus.NOT_PAID:
        return 'Incomplete'
      default:
        return 'Unknown Status'
    }
  }

  getStatusType (status: string): EStatusType {
    switch (status) {
      case EFacilityMonthlyBillingBatchStatus.PAID:
        return EStatusType.success
      case EFacilityMonthlyBillingBatchStatus.NOT_PAID:
        return EStatusType.attention
      default:
        return EStatusType.default
    }
  }

  generateMonthlyBillings (
    { invoiceTypes, batchDate, echeckBatchCloseTimeOptions }:
    { invoiceTypes: EZuntaInvoiceType[], batchDate: Date, echeckBatchCloseTimeOptions: Dictionary<DateRange<string>> }
  ) {
    this.isCreatingBilling = true
    Api.billing.generateMonthlyBillings(invoiceTypes, batchDate, echeckBatchCloseTimeOptions)
    setTimeout(() => {
      this.isCreatingBilling = false
      this.shouldConfirmCreateBatch = false
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Generating in process',
        header: `Generate Bill Invoices`,
        icon: 'check'
      })
    }, 3000)
  }

  showBatchHistory (item: IFacilityMonthlyBillingBatch | IUserFacilityMonthlyBillingBatch) {
    if (this.userId) {
      this.historyBatchId = (item as IUserFacilityMonthlyBillingBatch).batch as number
    } else {
      this.historyBatchId = item.id
    }
    this.shouldShowBillingBatchHistory = true
  }

  closeHistory () {
    this.shouldShowBillingBatchHistory = false
    this.historyBatchId = null
  }

  mounted () {
    this.$watch('$route', (oldVal, newVal) => {
      if (this.$refs.table && oldVal.params.name === newVal.params.name) {
        // @ts-ignore
        this.$refs.table.initSearch()
      }
    })
  }

  async updateBatch () {
    this.shouldConfirmUpdateBatch = false
    await Api.billing.updateBatch(this.batchIdToUpdate as number)
    this.batchIdToUpdate = null
    this.fetchBillingItems(this.prevFilters)
    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'Updating in process',
      header: `Update Billing Batch`,
      icon: 'check'
    })
  }

  async handleSelectAction (batch: IFacilityMonthlyBillingBatch, item: ISelectItem) {
    if (this.userId) {
      return null
    }
    switch (item.value) {
      case 'remove':
        this.batchIdToDelete = batch.id
        this.shouldConfirmDeleteBatch = true
        break
      case 'update':
        this.shouldConfirmUpdateBatch = true
        this.batchIdToUpdate = batch.id
        break
    }
  }

  async deleteBatch () {
    this.isDeletingBatch = true
    if (this.batchIdToDelete) {
      await this.chainModuleInstance.removeBatch(this.batchIdToDelete as number)
      await this.fetchBillingItems(this.prevFilters)
    }
    this.isDeletingBatch = false
    this.batchIdToDelete = null
    this.shouldConfirmDeleteBatch = false
  }

  async fetchBillingItems (filters: any) {
    const localFilters = {
      ...filters
    }
    this.prevFilters = filters
    if (this.userId) {
      localFilters.user = this.userId
    }
    clearTimeout(this.timeout)
    await this.chainModuleInstance.getBillingBatchesList(localFilters)
    this.timeout = setTimeout(() => {
      this.fetchBillingItems(this.prevFilters)
    }, 60 * 1000)
  }

  goToDetailsPage (item: any) {
    if (this.userId) {
      this.$router.push({
        name: 'admin-user-billing-details-commissions',
        params: { batch: item.batch.toString(), user: this.userId.toString() }
      })
    } else {
      this.$router.push({ name: 'admin-billing-details-commissions', params: { batch: item.id.toString() } })
    }
  }

  beforeDestroy () {
    clearTimeout(this.timeout)
  }
}
